<template>
  <div class="col-xs-12 col-sm-6 col-md-4">
    <div class="article text-center">
      <div class="image" :style="image ? 'background-image:url(' + image + ');' : ''">
        <router-link :to="{name: 'blog-article', params: {id: article.id}}">
        </router-link>
      </div>
      <div class="article-content" :class="image ? '' : 'no-image'">
        <h2><router-link :to="{name: 'blog-article', params: {id: article.id}}">{{article.title}}</router-link></h2>

        <p class="large-text">{{content}}</p>
      </div>
      <router-link :to="{name: 'blog-article', params: {id: article.id}}" class="btn-pub btn-pub-border-primary fixed-width xs-full-width">
        Read More
      </router-link>
    </div>
  </div>

</template>

<script>

  import { mapState, mapActions, mapGetters } from 'vuex';
  import _ from 'underscore'



  export default {
    props: {
      article: Object
    },

    components: {
    },

    created() {
      
    },

    methods: {
      
    },

    computed: {
      ...mapState([
      ]),
      content() {
        const html = this.article.content;
        let div = document.createElement("div");
        div.innerHTML = html;
        let text = div.textContent || div.innerText || "";
        return text;
      },
      image() {
        if (this.article.blog_images.length > 0) {
          return this.article.blog_images[0].image_url;
        }
        return null;
      }
    },

    data() {
      return {
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .article {margin:0px 15% 100px 15%;}
  .article .image { width: 100%; padding-top: 100%; position: relative; overflow: hidden; background-size: cover; background-repeat: no-repeat; background-position: center; background-color:#EEEEEE;}
  .article .image a { position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; }
    .article .article-content { overflow: hidden; height: 300px; margin-bottom: 40px; position: relative; margin-right: -2rem; padding-right: 2rem; }
  .article .article-content.no-image {}
  .article .article-content h2 { margin: 30px 0px; line-height: 30px; }
  .article .article-content h2 a {color:#111111;font-weight:500;}
  .article .article-content p { line-height: 30px;text-align:justify;}
  .article .article-content::before { content: '...'; position: absolute; right: 9px; bottom: 2px; }

  @media only screen and (max-width:1400px) {
    .article { margin: 0px 10% 80px 10%; }
  }

  @media only screen and (max-width:1100px) {
    .article { margin: 0px 7% 60px 7%; }
  }

  @media only screen and (max-width:992px) {
    .article { margin: 0px 4% 50px 4%; }
  }

</style>



// WEBPACK FOOTER //
// BlogListArticle.vue?abc7ef46